import { FilterParams } from '@synergy/models';
import { LeafIcon } from '@synergy/theme-next';
import { ReactElement } from 'react';
import { Stack, styled } from '@mui/material';

import { FilterToggle, FilterToggleProps } from '../../../../components/filter';

const EcoProductToggle = styled(FilterToggle)(() => ({
    flex: 1,
    width: 40,

    '& .MuiChip-label': {
        padding: 0,
    },
}));

export const EcoProductFilter = (props: Partial<FilterToggleProps>): ReactElement => {
    return (
        <EcoProductToggle
            {...props}
            color="success"
            filterParam={FilterParams.EcoProduct}
            label={
                <Stack>
                    <LeafIcon />
                </Stack>
            }
        />
    );
};
